import { useState, type InputHTMLAttributes } from 'react';

import { EyeIcon, EyeOffIcon } from './Icons';

type PasswordInputProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>;

export function PasswordInput({ className, ...props }: PasswordInputProps) {
  const [isVisible, setIsVisible] = useState(false);
  const actionLabel = isVisible ? 'Hide password' : 'Show password';

  return (
    <div className="password-input-wrap">
      <input
        {...props}
        className={`${className ?? 'input'} password-input`}
        type={isVisible ? 'text' : 'password'}
      />
      <button
        className="password-visibility-button"
        type="button"
        aria-label={actionLabel}
        aria-pressed={isVisible}
        title={actionLabel}
        onClick={() => setIsVisible((current) => !current)}>
        {isVisible ? <EyeOffIcon size={20} /> : <EyeIcon size={20} />}
      </button>
    </div>
  );
}
